export default {
    useReportFilter: false,
    texts: {
        count:
            'Showing {from} to {to} of {count} records|{count} records|One record',
        filteredCount:
            'Showing {from} to {to} of {count} records (filtered from {total} total entries)|{count} records (filtered from {total} total entries)|One record (filtered from {total} total entries)',
        limit: 'Records per page :',
        filterPlaceholder: 'Search...',
        loading: 'Loading...',
        filter: '',
        title: null,
        description: null,
    },
    compileTemplates: true,
    highlightMatches: true,
    pagination: {
        dropdown: false,
        chunk: 5,
    },
    checkbox: false,
    filterByColumn: false,
    datepickerOptions: {
        showDropdowns: true,
    },
    actionButtons: [],
    exports: {},
    pdf_url: false,
    csv_url: false,
    xlsx_url: false,
    create_btn: {},
    checkboxActions: [],
    // will be remove later
    checkbox_actions: {},
    perPageValues: [5, 10, 20, 40, 80],
    skin: 'table-striped table-hover table m-b-0 b-b',
    sortIcon: {
        is: 'sorting',
        up: 'sorting asc',
        down: 'sorting desc',
    },
    checkboxDisableCallback: row => false,
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable-options.js